
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ingredients-storage",
      function () {
        return require("private-next-pages/ingredients-storage/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ingredients-storage"])
      });
    }
  